import React, { useContext, useState } from "react";
import { CartCountContext } from "./CartNumbers";
import { totalAmount } from "../Body";

// You can now use the `totalAmount` variable here
console.log("Total Amount from Body.js:", totalAmount);


function ShoppingCart() {
  const { cartCount } = useContext(CartCountContext);
  return (
    <div>
      <div className="p-4 bg-white"></div>
      <div className="flex p-3 justify-between">
        <div>
          Miqdori
          <span>
            {" "}
            <strong> {cartCount}</strong>
          </span>
        </div>
        <div>
          <span>
            {" "}
            <strong>{totalAmount}</strong>{" "}
          </span>
          So'm
        </div>
      </div>
      <div className="flex flex-col h-32 justify-evenly mt-4 p-3">
        <button className="px-4 py-2 w-full mr-2 bg-blueColor text-white rounded hover:bg-blue-600 transition-colors duration-200">
          Sotib olish
        </button>
        <button className="px-4 py-2 w-full mr-2 text-black rounded hover:bg-blueColor hover:text-white transition-colors duration-200">
          Savatchaga qo'shish
        </button>
      </div>
    </div>
  );
}

export default ShoppingCart;
